import { useState } from 'react';
import { useForm } from '@inertiajs/react';

interface SubscribeFormProps {
  className?: string;
}

export function SubscribeForm({ className = '' }: SubscribeFormProps) {
  const { data, setData, post, processing, errors } = useForm({
    email: '',
    name: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    post('/blog/subscribe', {
      onSuccess: (page) => {
        const props = page.props as any;
        setSubmitted(true);
        if (props.success) {
          setMessage(props.message || 'Thanks for subscribing!');
          setIsError(false);
        } else {
          setMessage(props.error || 'Something went wrong');
          setIsError(true);
        }
      },
      onError: (err) => {
        setSubmitted(true);
        setMessage(err.email || 'Something went wrong');
        setIsError(true);
      }
    });
  };

  if (submitted) {
    return (
      <div className={className}>
        {isError ? (
          <div className="p-3 bg-red-100 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-md">
            <p className="text-sm text-red-600 dark:text-red-400">{message}</p>
            <button 
              onClick={() => setSubmitted(false)}
              className="text-xs text-red-500 dark:text-red-400 underline mt-1"
            >
              Try again
            </button>
          </div>
        ) : (
          <div className="p-3 bg-green-100 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-md">
            <p className="text-sm text-green-600 dark:text-green-400">{message}</p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      <h4 className="text-sm font-semibold text-foreground mb-2">
        Subscribe to our newsletter
      </h4>
      <p className="text-xs text-muted-foreground mb-3">
        Get the latest posts delivered to your inbox.
      </p>
      
      <form onSubmit={handleSubmit} className="space-y-2">
        <input
          type="text"
          name="name"
          value={data.name}
          onChange={(e) => setData('name', e.target.value)}
          className="w-full px-3 py-2 text-sm border border-input rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary bg-background text-foreground"
          placeholder="Your name (optional)"
        />
        
        <div className="flex space-x-2">
          <input
            type="email"
            name="email"
            required
            value={data.email}
            onChange={(e) => setData('email', e.target.value)}
            className="flex-1 px-3 py-2 text-sm border border-input rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary bg-background text-foreground"
            placeholder="you@example.com"
          />
          <button
            type="submit"
            disabled={processing}
            className="px-4 py-2 text-sm font-medium text-primary-foreground bg-primary hover:bg-primary/90 rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {processing ? '...' : 'Subscribe'}
          </button>
        </div>
        
        {errors.email && (
          <p className="text-xs text-red-500 dark:text-red-400">{errors.email}</p>
        )}
      </form>
    </div>
  );
}

export default SubscribeForm;
